import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-currency',
  templateUrl: './custom-sources-badge-currency.component.html',
  styleUrls: ['./custom-sources-badge-currency.component.scss']
})
export class CustomSourcesBadgeCurrencyComponent {
  @Input() public datasource: DatasetUsageComponentObject;
}
